import { Injectable } from '@angular/core';
import { TranslateService as ngxTranslate } from '@ngx-translate/core';

import { ProfileService } from './profile.service';
import { environment } from '__env';

@Injectable({
  providedIn: 'root',
})
export class TranslateService {
  private isReady = false;
  private readyPromise: Promise<void>;

  constructor(
    private ngxTranslate: ngxTranslate,
    private profileService: ProfileService,
  ) {
    this.readyPromise = new Promise((resolve) => {
      this.ngxTranslate.onLangChange.subscribe(() => {
        this.isReady = true;
        resolve();
      });
    });
  }

  ready(): Promise<void> {
    if (this.isReady) {
      return Promise.resolve();
    }
    return this.readyPromise;
  }

  async init() {
    await this.addLangs();
    await this.setDefaultLang();
    await this.useUserLang();
    await this.ready();
  }

  use(lang: string) {
    this.ngxTranslate.use(lang);
  }

  useUserLang() {
    const lang = this.profileService.language();
    this.use(lang);
  }

  getBrowserLang() {
    return this.ngxTranslate.getBrowserLang();
  }

  useBrowserLang() {
    const lang = this.getBrowserLang() || environment.LANGUAGE.Default;
    const langSupport = environment.LANGUAGE.Support as string[];
    if (langSupport.includes(lang)) {
      this.use(lang);
    }
  }

  translate(key: string, params?: any) {
    return this.ngxTranslate.instant(key, params);
  }

  private addLangs() {
    const langSupport = environment.LANGUAGE.Support as string[];
    this.ngxTranslate.addLangs(langSupport);
  }

  private setDefaultLang() {
    const lang = environment.LANGUAGE.Default;
    this.ngxTranslate.setDefaultLang(lang);
  }
}
